import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data
}
const onboardStores = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.bulkOnboardStores),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      mid: data.mid ? data.mid : undefined,
      storeCode: data.storeCode.toString(),
      institutionId: data.institutionId.toString(),
    },
  }
  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}
export { onboardStores }
